import { CaseState } from 'app/area/case/types-store';
import {
  getCaseData,
  getEntityContext,
  contextToStorePath
} from 'app/infrastructure/ui/renderer/resolvers';
import { StoreData, StoreField } from 'app/types-shared';
import { getById } from 'app/infrastructure/store/query';

const referenceFieldFromEntity = (state: CaseState, uiEngineProps: any) => {
  const properties =
    uiEngineProps.componentDescriptor &&
    uiEngineProps.componentDescriptor.properties;
  const referenceCodeDataTag = properties && properties.referenceCodeDataTag;

  if (!referenceCodeDataTag) {
    return undefined;
  }

  const caseData: StoreData = getCaseData(state, uiEngineProps);
  const context = getEntityContext(state, uiEngineProps);

  const entity = getById(
    caseData,
    contextToStorePath(uiEngineProps.componentDescriptor, context)
  );

  return entity && (entity[referenceCodeDataTag] as StoreField[]);
};

export const referenceFieldValue = (state: CaseState, uiEngineProps: any) => {
  const referenceField = referenceFieldFromEntity(state, uiEngineProps);

  return {
    categoryId:
      referenceField && referenceField.length > 0 && referenceField[0].value,
    referenceType:
      referenceField &&
      referenceField.length > 0 &&
      referenceField[0].categoryId
  };
};

export const referenceFieldValueAsPrimaryKey = (
  state: CaseState,
  uiEngineProps: any
) => {
  const referenceField = referenceFieldFromEntity(state, uiEngineProps);

  return {
    primaryKey: referenceField && referenceField.length > 0 && referenceField[0]
  };
};
